import { createClient } from '@supabase/supabase-js';

// Récupérer les variables d'environnement (à configurer dans .env)
const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

// Vérifier que les variables d'environnement sont définies
if (!supabaseUrl || !supabaseAnonKey) {
  console.error('Les variables d\'environnement Supabase ne sont pas définies correctement');
  console.log('URL:', supabaseUrl);
  console.log('Key:', supabaseAnonKey);
}

// Créer le client Supabase
export const supabase = createClient(
  supabaseUrl || 'https://supabase.hkcom.fr',
  supabaseAnonKey || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJyb2xlIjoiYW5vbiIsImlzcyI6InN1cGFiYXNlIiwiaWF0IjoxNzcxNjg3ODQ4LCJleHAiOjIwODcwNDc4NDh9.bZ_YSFt8riWl-nsWxNV9ZQLuqfrLa_k7E0lXofAU0Pc',
  { db: { schema: 'agence_interieurs' } }
);
